import Rest from '../rest';
import APPLICATION_CONSTANTS from '../applicationConstants';

/**
 *
 */
class GeocoderService {
  /**
   *
   * @param {*} address
   * @returns
   */
  geocodeByAddress(address) {
    return new Promise((resolve, reject) => {
      if (address) {
        window._geocoder.geocode({ address }, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            resolve(results);
          } else {
            reject(status);
          }
        });
      } else {
        resolve();
      }
    });
  }

  /**
   *
   * @param {*} coords
   * @returns
   */
  geocodeByCoords(coords) {
    return new Promise((resolve, reject) => {
      const { latitude, longitude } = coords;
      const location = {
        lat: parseFloat(latitude),
        lng: parseFloat(longitude),
      };
      window._geocoder.geocode({ location }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          const address = results[0]?.formatted_address;
          const components = results[0]?.address_components;

          resolve({ address, components });
        } else {
          reject();
        }
      });
    });
  }

  /**
   *
   * @returns
   */
  geocodeByIp() {
    return new Promise((resolve, reject) => {
      const url = `${process.env.LOCATOR_API}/GeoWrap`;
      let headers = null;
      let env = null;

      switch (process.env.NODE_ENV) {
        case 'development':
          env = 'GEO_WRAP_DEV';
          break;
        case 'qa':
          env = 'GEO_WRAP_QA';
          break;
        case 'staging':
          env = 'GEO_WRAP_STAGE';
          break;
        case 'production':
          env = 'GEO_WRAP_PROD';
          break;
      }

      if (APPLICATION_CONSTANTS.GLOBAL[env]) {
        headers = { ApiKey: APPLICATION_CONSTANTS.GLOBAL[env]};
      }

      Rest.get(url, { headers })
        .then(res => resolve(res?.data))
        .catch(error => reject(error));
    });
  }

  geocodeByLocation(options) {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        result => resolve(result?.coords),
        error => reject(error),
        options
      );
    });
  }

  /**
   *
   * @param {*} address
   * @returns
   */
  baiduGeocodeByAddress(address) {
    const apiKey = '5LIL44N8YdmRYuNTe8ssGLLq';
    const url = `${APPLICATION_CONSTANTS.GLOBAL.API_URL}/Practice/baiduGeocodeByAddress?address=${address}&output=json&ak=${apiKey}`;

    return new Promise((resolve, reject) => {
      Rest.get(url, { timeout: process.env.LOCATOR_API_TIMEOUT })
        .then(res => resolve(res?.data))
        .catch(error => reject(error));
    });
  }

  /**
   *
   * @param {*} coords
   * @returns
   */
  baiduGeocodeByCoords(coords) {
    const apiKey = '5LIL44N8YdmRYuNTe8ssGLLq';
    const { latitude, longitude } = coords;
    const url = `${APPLICATION_CONSTANTS.GLOBAL.API_URL}/Practice/baiduGeocodeByCoordinates?location=${latitude},${longitude}&output=json&ak=${apiKey}`;

    return new Promise((resolve, reject) => {
      Rest.get(url, { timeout: process.env.LOCATOR_API_TIMEOUT })
        .then(res => resolve(res?.data))
        .catch(error => reject(error));
    });
  }

  // WIP!!!
  /**
   *
   * @param {*} coords
   * @returns
   */
  yandexGeocodeByAddress(address) {
    const apiKey = 'ff7a8ef9-bd2c-4c9b-9a3c-4d14dff03082';
    const url = `https://geocode-maps.yandex.ru/1.x/?apikey=${apiKey}&geocode=${address}&lang=ru_RU&format=json
`
    return new Promise((resolve, reject) => {
      Rest.get(url, { timeout: process.env.LOCATOR_API_TIMEOUT })
        .then(res => resolve(res?.data.response))
        .catch(error => reject(error));
    });
  }

  // WIP!!!
  /**
   *
   * @param {*} coords
   * @returns
   */
  yandexGeocodeByCoords(coords) {
    const apiKey = 'ff7a8ef9-bd2c-4c9b-9a3c-4d14dff03082';
    const { latitude, longitude } = coords;
    const url = `https://geocode-maps.yandex.ru/1.x/?apikey=${apiKey}&geocode=${longitude},${latitude}&lang=ru_RU&format=json`;

    return new Promise((resolve, reject) => {
      Rest.get(url, { timeout: process.env.LOCATOR_API_TIMEOUT })
        .then(res => resolve(res?.data.response))
        .catch(error => reject(error));
    });
  }
}

export default GeocoderService;
